import React, { useEffect, useState } from 'react';
import './HistoryPage.css';
import logo from '../assets/logo.png';

export default function HistoryPage({ authToken, onLogout, user }) {
    const [historico, setHistorico] = useState([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);
    const [filtro, setFiltro] = useState('');
    const [tipoFiltro, setTipoFiltro] = useState('todos');

    useEffect(() => {
        async function carregarHistorico() {
            try {
                if (!user || !authToken) {
                    setLoading(false);
                    return;
                }
                const phone = user.whatsapp;
                const params = new URLSearchParams();
                if (phone) params.append('phone', phone);

                const queryString = params.toString();
                const url = `${process.env.REACT_APP_API_URL || ''}/api/historico${queryString ? '?' + queryString : ''}`;

                const res = await fetch(url, {
                    headers: { Authorization: `Bearer ${authToken}` },
                });
                if (!res.ok) throw new Error('Erro ao carregar histórico.');
                const data = await res.json();
                setHistorico(data.historico || []);
            } catch (e) {
                setErro('Erro ao carregar histórico. Tente novamente mais tarde.');
            } finally {
                setLoading(false);
            }
        }
        carregarHistorico();
    }, [user, authToken]);

    function handleClickShowResult(key) {
        const link = `https://analisecentral.com.br/consulta-resultado?key=${key}`;
    }

    function formatarData(dataStr) {
        if (!dataStr) return '-';
        const date = new Date(dataStr);
        if (isNaN(date)) return dataStr;
        return date.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    function getStatusBadge(status, sucesso) {
        const s = status?.toLowerCase() || '';
        if (s === 'concluido' || s === 'concluído' || sucesso === true || sucesso === 'true') {
            return <span className="status-badge success">Concluído</span>;
        }
        if (s === 'pendente' || s === 'processando') {
            return <span className="status-badge warning">Processando</span>;
        }
        if (s === 'erro' || s === 'falha' || sucesso === false || sucesso === 'false') {
            return <span className="status-badge error">Erro</span>;
        }
        return <span className="status-badge">{status || 'Concluído'}</span>;
    }

    function getTipoIcon(tipo) {
        const t = tipo?.toLowerCase() || '';
        if (t.includes('cpf')) return '🆔';
        if (t.includes('cnpj')) return '🏢';
        if (t.includes('telefone') || t.includes('tel')) return '📱';
        if (t.includes('email') || t.includes('e-mail')) return '📧';
        if (t.includes('pix')) return '💸';
        if (t.includes('nome')) return '👤';
        return '🔍';
    }

    const tiposUnicos = ['todos', ...new Set(historico.map(h => h.type).filter(Boolean))];

    const historicoFiltrado = historico.filter((c) => {
        const matchFiltro = !filtro ||
            (c.param || '').toLowerCase().includes(filtro.toLowerCase()) ||
            (c.type || '').toLowerCase().includes(filtro.toLowerCase());
        const matchTipo = tipoFiltro === 'todos' || c.type === tipoFiltro;
        return matchFiltro && matchTipo;
    });

    const totalConsultas = historico.length;
    const consultasHoje = historico.filter(h => {
        const d = new Date(h.created_at);
        const hoje = new Date();
        return d.toDateString() === hoje.toDateString();
    }).length;
    const consultasConcluidas = historico.filter(h => {
        const s = h.status?.toLowerCase() || '';
        return s === 'sucesso' || s === 'concluído' || h.sucesso === true || h.sucesso === 'true';
    }).length;

    if (loading) {
        return (
            <div className="history-root">
                <div className="history-loading">
                    <div className="spinner-lg"></div>
                    <p>Carregando seu histórico de consultas...</p>
                </div>
            </div>
        );
    }

    if (erro) {
        return (
            <div className="history-root">
                <div className="history-erro">
                    <div className="erro-icon">⚠️</div>
                    <h2>Ocorreu um erro</h2>
                    <p>{erro}</p>
                    <button className="btn-primary" onClick={() => window.location.reload()}>
                        Tentar novamente
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="history-root">
            {/* Header */}
            <header className="history-header">
                <div className="container">
                    <div className="history-header-inner">
                        <a href="/" className="history-logo"><img src={logo} alt="AnaliseCentral" style={{height: '100px'}} /></a>
                        <nav className="history-header-nav">
                            <a href="/">Inicio</a>
                            <a href="#" className="active">Histórico</a>
                            <a href="/recargas">Recargas</a>
                        </nav>
                        <div className="history-user">
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span className="user-name">{user?.empresa || 'Conta autenticada'}</span>
                                <span
                                    className={`creditInfo ${user?.creditsExpired ? "creditExpired" : ''
                                        }`}
                                >
                                    {user?.credits ?? 0} {
                                        user?.creditsExpired ? 'expirados' : ' créditos'
                                    }
                                </span>
                            </div>
                            <button className="btn-sair" onClick={onLogout}>Sair</button>

                            <button className="btn-back" onClick={() => window.history.back()} >Voltar</button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Hero */}
            <div className="history-hero">
                <div className="container">
                    <span className="history-hero-label">Área do Cliente</span>
                    <h1>Histórico de <span className="heroAccent">Consultas</span></h1>
                    <p className="history-hero-desc">
                        Acompanhe todas as consultas realizadas, visualize resultados e gerencie seu histórico.
                    </p>
                </div>
            </div>

            <div className="history-layout container">
                {/* Stats */}
                <div className="stats-grid">
                    <div className="stat-card">
                        <div className="stat-icon">📊</div>
                        <div className="stat-info">
                            <span className="stat-value">{totalConsultas}</span>
                            <span className="stat-label">Total de consultas</span>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon">📅</div>
                        <div className="stat-info">
                            <span className="stat-value">{consultasHoje}</span>
                            <span className="stat-label">Consultas hoje</span>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon">✅</div>
                        <div className="stat-info">
                            <span className="stat-value">{consultasConcluidas}</span>
                            <span className="stat-label">Concluídas</span>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon">⏱️</div>
                        <div className="stat-info">
                            <span className="stat-value">30 dias</span>
                            <span className="stat-label">Validade do relatório</span>
                        </div>
                    </div>
                </div>

                {/* Filtros */}
                <div className="filtros-bar">
                    <div className="filtro-search">
                        <span className="search-icon">🔍</span>
                        <input
                            type="text"
                            placeholder="Buscar por parâmetro ou tipo..."
                            value={filtro}
                            onChange={(e) => setFiltro(e.target.value)}
                        />
                    </div>
                    <div className="filtro-tipo">
                        <select value={tipoFiltro} onChange={(e) => setTipoFiltro(e.target.value)}>
                            {tiposUnicos.map((t) => (
                                <option key={t} value={t}>
                                    {t === 'todos' ? 'Todos os tipos' : t.toUpperCase()}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Tabela ou Vazio */}
                {!Array.isArray(historico) || historico.length === 0 ? (
                    <div className="history-vazio">
                        <div className="vazio-icon">📭</div>
                        <h2>Nenhuma consulta encontrada</h2>
                        <p>Você ainda não realizou nenhuma consulta. Comece agora mesmo!</p>
                        <a href="/" className="btn-primary">Realizar primeira consulta</a>
                    </div>
                ) : historicoFiltrado.length === 0 ? (
                    <div className="history-vazio">
                        <div className="vazio-icon">🔍</div>
                        <h2>Nenhum resultado para o filtro</h2>
                        <p>Tente ajustar os critérios de busca.</p>
                        <button className="btn-secondary" onClick={() => { setFiltro(''); setTipoFiltro('todos'); }}>
                            Limpar filtros
                        </button>
                    </div>
                ) : (
                    <div className="table-wrapper">
                        <div className="table-header">
                            <span className="table-count">
                                {historicoFiltrado.length} {historicoFiltrado.length === 1 ? 'consulta' : 'consultas'} encontrada{historicoFiltrado.length === 1 ? '' : 's'}
                            </span>


                        </div>
                        <div className="table-responsive">
                            <table className="history-table">
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Parâmetro</th>
                                        <th>Data</th>
                                        <th>Status</th>
                                        <th>Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historicoFiltrado.map((c, i) => (
                                        <tr key={i}>
                                            <td>
                                                <div className="tipo-cell">
                                                    <span className="tipo-icon">{getTipoIcon(c.type)}</span>
                                                    <span className="tipo-text">{c.type?.toUpperCase() || '-'}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="param-text">{c.param || '-'}</span>
                                            </td>
                                            <td>
                                                <span className="data-text">{formatarData(c.created_at)}</span>
                                            </td>
                                            <td>{getStatusBadge(c.status, c.sucesso)}</td>
                                            <td>
                                                {c.key && (c.type == "cpf" || c.type == "cnpj") ? (


                                                    <a
                                                        href={`https://analisecentral.com.br/consulta-resultado?key=${c.key}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn-ver"
                                                    >
                                                        <span>👁️</span>
                                                    </a>
                                                ) : (
                                                    <span className="sem-acao">—</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* Footer */}
            <footer className="history-footer">
                <div className="container">
                    <div className="history-footer-inner">
                        <p>© Análise Central. Todos os direitos reservados.</p>
                        <div className="history-footer-links">
                            <a href="/">Página Inicial</a>
                            <a href="#">Termos de Uso</a>
                            <a href="#">Política de Privacidade</a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}